// cartActions.js (NEW FILE)

import {
  addItemToCart,
  clearLocalCart,
  removeItemFromCart,
  increaseQty,
} from "./cartSlice";
import {
  addToCartAPI,
  updateToCartAPI,
  fetchCartAPI,
  removeFromCartAPI,
} from "./thunk";
import { toast } from "sonner";

export const addToCart = (product) => (dispatch, getState) => {
  const { auth } = getState();

  const isAuthenticated = !!auth.user;

  if (isAuthenticated) {
    dispatch(addToCartAPI(product)); // API
  } else {
    dispatch(addItemToCart(product)); // local
  }
};

// export const updateCart = (product) => (dispatch, getState) => {};

export const increaseCartQty = (item) => (dispatch, getState) => {
  const { auth } = getState();

  const isAuthenticated = !!auth.user;
  if (item?.type === "addition") {
    if (isAuthenticated) {
      dispatch(
        updateToCartAPI({
          ProductId: item.productId,
          Quantity: item.quantity,
        }),
      ); // API
    } else {
      dispatch(increaseQty(item)); // local
    }
  } else {
    if (isAuthenticated) {
      dispatch(
        updateToCartAPI({
          ProductId: item.productId,
          Quantity: item.quantity,
        }),
      ); // API
      // dispatch(removeFromCart(item?.productId));
    } else {
      dispatch(removeFromCart(item.id));
    }
  }
};
// const decrementQuantity = () => {
//   if (authUser?.accessToken) {
//     dispatch(removeFromCart(currentItem?.productId));
//   } else {
//     dispatch(removeFromCart(currentItem.id));
//   }
//   // dispatch(removeFromCart(currentItem.id));
// };
// export const increaseCartQty = (item) => (dispatch, getState) => {
//   const { auth } = getState();

//   if (auth.user) {
//     dispatch(addToCartAPI({ ...item }));
//   } else {
//     dispatch(increaseQty(item));
//   }
// };

export const removeFromCart = (id) => (dispatch, getState) => {
  const { auth } = getState();
  if (auth.user) {
    dispatch(removeFromCartAPI(id));
  } else {
    dispatch(removeItemFromCart(id));
  }
};

export const syncCartOnLogin = () => async (dispatch, getState) => {
  try {
    const localCart = getState().itemCart.cart;

    // 🔹 Step 1: Push local cart to server
    if (localCart.length > 0) {
      for (const item of localCart) {
        const res = await dispatch(
          addToCartAPI({
            id: item.id,
            quantity: item.quantity,
          }),
        );

        // stop if any request fails
        if (res.meta.requestStatus !== "fulfilled") {
          console.error("Failed to sync item:", item);
          toast.error("Failed to sync item:", JSON.stringify(item));
          return;
        }
      }

      // 🔹 Step 2: Clear local cart AFTER successful sync
      dispatch(clearLocalCart());
    }

    // 🔹 Step 3: Fetch fresh server cart
    await dispatch(fetchCartAPI());
  } catch (error) {
    console.error("syncCartOnLogin error:", error);
    toast.error("syncCartOnLogin error:", JSON.stringify(error));
  }
};
